// Generates a wa.me link with a pre-filled message for a given category.
// The phone number maps to 929.605.7254 (US +1).
const WHATSAPP_NUMBER = "19296057254";

export function whatsappLink(message) {
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
}

export function categoryWhatsappLink(categoryName, lang = "en") {
  const msg =
    lang === "pt"
      ? `Olá! Tenho interesse em uma peça da categoria ${categoryName}.`
      : `Hello! I'm interested in a piece from the ${categoryName} category.`;
  return whatsappLink(msg);
}
